"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListCondition = void 0;
const condition_1 = require("./condition");
const join_condition_1 = require("./join-condition");
const list_count_type_1 = require("./list-count-type");
const _ = __importStar(require("lodash"));
class ListCondition extends condition_1.Condition {
    constructor() {
        super(...arguments);
        this.listAccessor = '';
        this.countType = list_count_type_1.ListCountType.atLeast;
        this.count = 0;
        this.condition = new join_condition_1.JoinCondition();
    }
    static atLeast(listAccessor, condition, count = 1) {
        let listCondition = new ListCondition();
        return _.extend(listCondition, { listAccessor, countType: list_count_type_1.ListCountType.atLeast, count, condition });
    }
    static exactly(listAccessor, condition, count = 0) {
        let listCondition = new ListCondition();
        return _.extend(listCondition, { listAccessor, countType: list_count_type_1.ListCountType.exactly, count, condition });
    }
}
exports.ListCondition = ListCondition;



//////////////////
// WEBPACK FOOTER
// ./~/rules-config/lib/list-condition.js
// module id = 1255
// module chunks = 0